import { render, staticRenderFns } from "./mapLittle.vue?vue&type=template&id=2c4af9b6&scoped=true"
import script from "./mapLittle.vue?vue&type=script&lang=js"
export * from "./mapLittle.vue?vue&type=script&lang=js"
import style0 from "./mapLittle.vue?vue&type=style&index=0&id=2c4af9b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4af9b6",
  null
  
)

export default component.exports